// extracted by mini-css-extract-plugin
export default {"endgame":"EndGame_endgame__ESgtB","endgame-modal":"EndGame_endgame-modal__dpHm9"};